<template>
	<div class="view-wrapper">
				<div class="row">
			<div class="col">

				<b-card header-tag="h5" header="Weapons" class="mb-3">
				</b-card>

			</div>
		</div>

		<div class="row">
			<div class="col">

				<b-card header-tag="h5" header="Armor" class="mb-3">
				</b-card>

			</div>
		</div>

		<div class="row">
			<div class="col">

				<b-card header-tag="h5" header="Shield">
				</b-card>

			</div>
		</div>
	</div>
</template>

<script>
export default {
	
}
</script>

<style scoped>

</style>